import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';

export type UnmatchOfferContentInput = {
    declinedParty: String;
    reason: String;
}

export const UNMATCH_OFFER_MUTATION = gql`
    mutation($payload: UnmatchOfferContentInput!, $offerId: ID!){
        unmatchOffer(payload: $payload, id: $offerId){
            bhpnDecisionDate
            comments
            declinedDate
            declinedParty
            declinedReason
            directCareHours
            firstServiceDate
            groupCareHours
            guid
            highLevelSupervisionHours
            id
            lastServiceDate
            midLevelSupervisionHours
            offerHourPercentage
            otherClinicLocation
            provideAllEstimatedHours
            provideServiceInRequiredLanguage
            provideServicesInClinic
            status
            submittedAt
        }
    }
`;

export const useUnmatchOffer = (
    offerId: string,
) => {
    const [
        execute,
        {
            error,
            loading
        }
    ] = useMutation(UNMATCH_OFFER_MUTATION);

    const unmatchOffer = useCallback(async (payload: UnmatchOfferContentInput) => {
            await execute({
                variables: {
                    offerId,
                    payload,
                }
            })
    }, [execute, offerId]);


    return {
        unmatchOffer,
        error,
        loading
    };
};
